var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_vm._m(0),(
        _vm.user &&
        !_vm.user.isProvider &&
        _vm.$can({ key: 'clients', expectedPermission: 'create' })
      )?_c('div',{staticClass:"col text-right"},[_c('router-link',{staticClass:"btn btn-outline-blue btn-sm-mobile py-2",attrs:{"to":{ name: 'patients.add' }}},[_c('icon',{attrs:{"type":"plus"}}),_vm._v(" Add New Client ")],1)],1):_vm._e()]),_c('list-patients')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-6 col-md-8"},[_c('h1',[_vm._v("Clients")])])
}]

export { render, staticRenderFns }